/**
 * VELLUM purchase social-proof toast (bottom-left).
 * Shows randomized Turkish names: "Ayşe Y****" + product + optional set qty.
 */
(function () {
  'use strict';

  const FIRST_NAMES = [
    'Ayşe', 'Elif', 'Zeynep', 'Fatma', 'Merve', 'Selin', 'Deniz', 'Ece', 'İrem', 'Büşra',
    'Mehmet', 'Ahmet', 'Emre', 'Can', 'Burak', 'Yusuf', 'Kerim', 'Oğuz', 'Arda', 'Efe',
    'Defne', 'Melis', 'Ceren', 'Naz', 'Sude', 'Berk', 'Kaan', 'Onur', 'Tolga', 'Baran',
  ];

  const LAST_INITIALS = 'ABCDGHIJKLMNOPRSTUVYZ'.split('');

  const TIME_LABELS = [
    'az önce',
    '1 dk önce',
    '2 dk önce',
    '3 dk önce',
    '5 dk önce',
    '8 dk önce',
    '12 dk önce',
    '18 dk önce',
    'yarım saat önce',
  ];

  const SET_QTYS = [1, 1, 1, 2, 2, 3];

  function rand(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function pick(arr) {
    return arr[rand(0, arr.length - 1)];
  }

  function maskName() {
    const first = pick(FIRST_NAMES);
    const initial = pick(LAST_INITIALS);
    return first + ' ' + initial + '****';
  }

  function shortTitle(title) {
    return String(title || '')
      .replace(/^VELLUM\s*[—–-]\s*/i, '')
      .replace(/^VELLUM\s+/i, '')
      .trim();
  }

  function buildAction(product, qty) {
    const name = shortTitle(product.title);
    const sets = Number(qty) || 1;
    if (sets === 2) return name + "'ni 2 set olarak satın aldı";
    if (sets === 3) return name + "'ni 3 set olarak satın aldı";
    return name + "'ni satın aldı";
  }

  function init(root) {
    if (!root || root.dataset.bound === '1') return;
    root.dataset.bound = '1';

    const catalogEl = document.querySelector('[data-vellum-toast-catalog]');
    let catalog = [];
    try {
      catalog = catalogEl ? JSON.parse(catalogEl.textContent || '[]') : [];
    } catch (e) {
      catalog = [];
    }
    // Only Divit set (allow_sets) — never standalone journal alerts
    catalog = catalog.filter((p) => p && p.title && p.allow_sets !== false);
    if (!catalog.length) return;

    const nameEl = root.querySelector('[data-vellum-toast-name]');
    const actionEl = root.querySelector('[data-vellum-toast-action]');
    const timeEl = root.querySelector('[data-vellum-toast-time]');
    const mediaEl = root.querySelector('[data-vellum-toast-media]');
    const closeBtn = root.querySelector('[data-vellum-toast-close]');

    const delayMin = Number(root.dataset.delayMin || 6);
    const delayMax = Number(root.dataset.delayMax || 14);
    const intervalMin = Number(root.dataset.intervalMin || 22);
    const intervalMax = Number(root.dataset.intervalMax || 40);
    const displaySec = Number(root.dataset.display || 7);

    let hideTimer = null;
    let loopTimer = null;
    let dismissed = false;
    let recentKeys = [];

    function isCartOpen() {
      return document.documentElement.classList.contains('vellum-scroll-lock');
    }

    function uniqueEvent() {
      let product;
      let qty;
      let key;
      let tries = 0;
      do {
        product = pick(catalog);
        qty = pick(SET_QTYS);
        key = product.title + '|' + qty;
        tries += 1;
      } while (recentKeys.includes(key) && tries < 8);

      recentKeys.push(key);
      if (recentKeys.length > 4) recentKeys.shift();
      return { product, qty };
    }

    function render() {
      if (dismissed || document.hidden || isCartOpen()) return;

      const event = uniqueEvent();
      const product = event.product;
      const person = maskName();
      const action = buildAction(product, event.qty);
      const time = pick(TIME_LABELS);

      if (nameEl) nameEl.textContent = person;
      if (actionEl) actionEl.textContent = action;
      if (timeEl) timeEl.textContent = time;

      if (mediaEl) {
        mediaEl.innerHTML = '';
        if (product.image) {
          const img = document.createElement('img');
          img.src = product.image;
          img.alt = '';
          img.width = 56;
          img.height = 56;
          img.loading = 'lazy';
          mediaEl.appendChild(img);
        }
        if (product.url) {
          mediaEl.style.cursor = 'pointer';
          mediaEl.onclick = function () {
            window.location.href = product.url;
          };
        }
      }

      root.hidden = false;
      root.classList.remove('is-leaving');
      void root.offsetWidth;
      root.classList.add('is-visible');

      clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, displaySec * 1000);
    }

    function hide() {
      root.classList.remove('is-visible');
      root.classList.add('is-leaving');
      clearTimeout(hideTimer);
      setTimeout(function () {
        root.hidden = true;
        root.classList.remove('is-leaving');
      }, 320);
    }

    function scheduleNext(isFirst) {
      clearTimeout(loopTimer);
      if (dismissed) return;
      const min = isFirst ? delayMin : intervalMin;
      const max = isFirst ? delayMax : intervalMax;
      const wait = rand(Math.max(1, min), Math.max(min, max)) * 1000;
      loopTimer = setTimeout(function () {
        render();
        scheduleNext(false);
      }, wait);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dismissed = true;
        hide();
        clearTimeout(loopTimer);
      });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        clearTimeout(loopTimer);
        clearTimeout(hideTimer);
      } else if (!dismissed) {
        scheduleNext(true);
      }
    });

    scheduleNext(true);
  }

  function boot() {
    const root = document.querySelector('[data-vellum-purchase-toast]');
    if (root) init(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
